module.exports = __webpack_public_path__ + "af9de96cede8f711667b06c1f93c5fc1.pdf";